// Kontekst FIRMY (docs/model-kluczy-firmowych.md) — F8: ZASTĄPIŁ UserProfileContext.
// components/CompanyProvider go montuje bezwarunkowo w App.tsx; niesie TOŻSAMOŚĆ firmy
// i listę jej uprawnień (EPrivileges). Klucz firmy NIE jest tu przenoszony (I4) — jego
// materiał żyje wyłącznie w warstwie krypto (utils/companyContentKeys), odtwarzany z grantu
// przy starcie sesji, nigdy w localStorage ani w żadnym kontekście trzymanym „na później".
//
// Wartości domyślne (bez dostawcy — np. w testach jednostkowych renderowanych bez drzewa
// providerów) są celowo „puste, ale nieblokujące": hasCompany=false, hasPrivilege()=false.

import { createContext } from "react";

import { ICompany } from "dto/ICompany";
import { EPrivileges } from "dto/EPrivileges";

export type ICompanyContext = {
  /** Firma zalogowanego; null gdy konto jej nie ma (D2 — konto może istnieć bez firmy). */
  company: ICompany | null;
  /** Uprawnienia zalogowanego w tej firmie (wartości EPrivileges wyliczone z jego roli). */
  privileges: string[];
  /** Skrót na `company !== null`; false → components/NoCompanyGate (D2). */
  hasCompany: boolean;
  /** Trwa pobieranie firmy. Zawsze false bez zamontowanego CompanyProvider. */
  isLoading: boolean;
  /** Wygodny predykat na `privileges`. Zwraca false przy braku dostawcy. */
  hasPrivilege: (privilege: EPrivileges | string) => boolean;
};

const CompanyContext = createContext<ICompanyContext>({
  company: null,
  privileges: [],
  hasCompany: false,
  isLoading: false,
  hasPrivilege: () => false,
});

export default CompanyContext;
